var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2132 12.63L8.53388 3H3V21H8.80165V11.37L15.4661 21H21V3H15.2132V12.63Z",
    fill: "#03C75A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNaver);
export default __webpack_public_path__ + "static/media/social-naver.993397d7b417c15e69fb99e56b476cd1.svg";
export { ForwardRef as ReactComponent };